/*
 * Sección Salidas: salidas marcadas en el periodo con las horas trabajadas del día, y aparte las
 * jornadas con entrada pero sin salida (en curso hoy, o incompletas de días pasados, que no suman
 * horas: spec 4.1). Sin salida anticipada ni horas extra (decisión del usuario, spec 4.3).
 */
import React, {useEffect, useState} from "react";
import StateView from "../components/StateView";
import SectionHeader from "../components/SectionHeader";
import StatTile from "../components/StatTile";
import StatusBadge from "../components/StatusBadge";
import EmployeeName from "../components/EmployeeName";
import Paginator from "../components/Paginator";
import {exitBadge, exitList, exitSummary, hhmm, paginate, pendingExits} from "../utils/rows";
import {buildParams, shortDayLabel} from "../utils/period";

const Salidas = ({rows, status, message, onRetry, filters, range, token, canExport, resetKey}) => {
    const [page, setPage] = useState(1);
    const [pendingPage, setPendingPage] = useState(1);
    useEffect(() => {
        setPage(1);
        setPendingPage(1);
    }, [resetKey]);

    const list = exitList(rows);
    const pending = pendingExits(rows);
    const summary = exitSummary(rows);
    const current = paginate(list, page);
    const currentPending = paginate(pending, pendingPage);
    const multiDay = range.desde !== range.hasta;

    const renderRow = (row, time) => {
        const badge = exitBadge(row);
        return (
            <li key={`${row.fecha}-${row.id_empleado}`} className="mc-list__item">
                <EmployeeName row={row}/>
                <span className="mc-list__time mc-num">
                    {time}
                    {multiDay && <small>{shortDayLabel(row.fecha)}</small>}
                </span>
                <StatusBadge tone={badge.tone} text={badge.text}/>
            </li>
        );
    };

    return (
        <section className="mc-section" aria-labelledby="mc-title-salidas">
            <SectionHeader id="mc-title-salidas" title="Salidas" canExport={canExport} token={token} range={range}
                           exportParams={buildParams(filters, range, {seccion: 'salidas'})}/>
            <StateView status={status} message={message} onRetry={onRetry} isEmpty={list.length === 0 && pending.length === 0}>
                <div className="mc-tiles">
                    <StatTile label="Salidas marcadas" value={summary.salidas} hint={`Hora promedio ${summary.horaPromedio}`}/>
                    <StatTile label="En curso" value={summary.enCurso} hint="Aún sin marcar salida hoy"/>
                    <StatTile label="Sin salida" value={summary.sinSalida} tone={summary.sinSalida ? 'down' : 'neutral'}
                              hint="Días pasados: no suman horas"/>
                    <StatTile label="Salidas sin almuerzo" value={summary.sinAlmuerzo}
                              tone={summary.sinAlmuerzo ? 'down' : 'neutral'} hint="Jornadas completas sin marcar almuerzo"/>
                    <StatTile label="Salidas sin entrada" value={summary.sinEntrada}
                              tone={summary.sinEntrada ? 'down' : 'neutral'} hint="Marcaron salida sin entrada"/>
                </div>
                <div className="mc-panel">
                    <h3 className="mc-panel__title">Salidas marcadas</h3>
                    {list.length === 0
                        ? <p className="mc-inline-empty">Nadie marcó salida en este rango.</p>
                        : <ul className="mc-list">{current.items.map((row) => renderRow(row, hhmm(row.salida)))}</ul>}
                    <Paginator page={current.page} pages={current.pages} onChange={setPage}/>
                </div>
                {pending.length > 0 &&
                    <div className="mc-panel">
                        <h3 className="mc-panel__title">Sin marca de salida</h3>
                        <ul className="mc-list">{currentPending.items.map((row) => renderRow(row, `Entró ${hhmm(row.entrada)}`))}</ul>
                        <Paginator page={currentPending.page} pages={currentPending.pages} onChange={setPendingPage}/>
                    </div>}
            </StateView>
        </section>
    );
};

export default Salidas;
